import React from "react";
import { IconButton, Badge } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function CartIcon() {
  const { cart } = useCart();
  const navigate = useNavigate();

  const totalQty = cart.reduce((sum, i) => sum + i.qty, 0);

  return (
    <IconButton color="none" onClick={() => navigate("/order")}>
      <Badge
        badgeContent={totalQty}
        color="error"
        overlap="circular"
        invisible={totalQty === 0}
      >
        <ShoppingCartIcon fontSize="medium" />
      </Badge>
    </IconButton>
  );
}
